module.exports = __webpack_public_path__ + "static/media/select.996ec882.svg";